<template>
  <div id="login">
    <div>
      <img src="../assets/common/logo_blue.svg" alt="구로구 중장년 일드림센터 로고"/>
      <input type="text" v-model="userId" @keyup.enter="login" placeholder="ID를 입력하세요"/>
      <input type="password" v-model="password" @keyup.enter="login" placeholder="패스워드를 입력하세요"/>
      <div @click="login">로그인</div>
    </div>
  </div>
</template>

<script>
import common from '../script/common'
import user from '../script/user'

export default {
  data () {
    return {
      userId: '',
      password: ''
    }
  },
  mounted () {
  },
  methods: {
    login () {
      if (!common.checkValidateData('string', this.userId)) {
        common.amsAlert('general', 'ID를 입력하세요.')
        return
      }
      if (!common.checkValidateData('string', this.password)) {
        common.amsAlert('general', '패스워드를 입력하세요.')
        return
      }
      user.login({
        userId: this.userId,
        password: this.password
      }, response => {
        console.log('로그인', response)
        if (response.data.resultCode === 1) {
          common.amsAlert('general', '로그인되었습니다.')
          this.$router.replace('/Dashboard')
        } else {
          common.amsAlert('retry', '로그인하지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
#login {
  display: flex;
  width: 100vw;
  height: 100vh;
}

#login > div {
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 20px;
  border: 1px solid #F4F4F4;
  border-radius: 10px;
  margin: auto;
  gap: 15px;
  box-sizing: border-box;
}

#login > div > div {
  margin: auto;
  display: flex;
  width: 130px;
  height: 56px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  background: #3E54EB;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue